import {
  CSVIcon,
  DatabaseIcon,
  ExcelIcon,
  FileIcon,
  ImageIcon,
  PDFIcon,
  PowerPointIcon,
  WordIcon,
} from "@cynthai/icons";
import type { FileType } from "@cynthai/shared";
import { getFileTypeByName } from "@cynthai/shared";

const fileTypeIconMap: Record<FileType, typeof PDFIcon> = {
  pdf: PDFIcon,
  csv: CSVIcon,
  excel: ExcelIcon,
  image: ImageIcon,
  powerpoint: PowerPointIcon,
  word: WordIcon,
  database: DatabaseIcon,
  unknown: FileIcon,
};

const sizeMap = {
  sm: "h-3 w-3",
  md: "h-4 w-4",
  lg: "h-5 w-5",
} as const;

function isDatabaseType(type: string): boolean {
  const t = type.toLowerCase();
  return (
    t.includes("database") ||
    t.includes("sql") ||
    t.includes("postgres") ||
    t.includes("mysql")
  );
}

interface FileTypeIconProps {
  readonly filename: string;
  readonly databaseType?: string;
  readonly size?: keyof typeof sizeMap;
  readonly className?: string;
}

export default function FileTypeIcon({
  filename,
  databaseType,
  size = "md",
  className = "",
}: FileTypeIconProps) {
  const iconClass = `${sizeMap[size]} ${className}`;

  if (databaseType && isDatabaseType(databaseType)) {
    return <DatabaseIcon className={iconClass} />;
  }

  const fileType = getFileTypeByName(filename);
  const Icon = fileTypeIconMap[fileType];
  return <Icon className={iconClass} />;
}
